module.exports = __webpack_public_path__ + "static/media/pistol-safes.a49b9ebf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/hero/pistol-safes.jpg
// module id = 1241
// module chunks = 0